const authReducer = (
  state = {
    isLogin:
      localStorage.SISMART_IS_LOGIN !== undefined &&
      localStorage.SISMART_IS_LOGIN === "true"
        ? true
        : false,
    user_id: localStorage.SISMART_USER_ID || "",
    user_level: localStorage.SISMART_USER_LEVEL || "",
    user_nama: localStorage.SISMART_USER_NAMA || "",
    user_foto: localStorage.SISMART_USER_FOTO || "",
    user_username: localStorage.SISMART_USER_USERNAME || "",
    user_status: localStorage.SISMART_USER_STATUS || "",
    user_token: localStorage.token || "",
  },
  action
) => {
  switch (action.type) {
    case "UPDATE_STATUS_LOGIN":
      localStorage.SISMART_IS_LOGIN = action.status;
      localStorage.SISMART_USER_ID = action.user_id;
      localStorage.SISMART_USER_LEVEL = action.user_level;
      localStorage.SISMART_USER_NAMA = action.user_nama;
      localStorage.SISMART_USER_FOTO = action.user_foto;
      localStorage.SISMART_USER_USERNAME = action.user_username;
      localStorage.SISMART_USER_STATUS = action.user_status;
      localStorage.token = action.user_token;

      return {
        ...state,
        isLogin: action.status,
        user_id: action.user_id,
        user_level: action.user_level,
        user_nama: action.user_nama,
        user_foto: action.user_foto,
        user_username: action.user_username,
        user_status: action.user_user_status,
        user_token: action.user_user_token,
      };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js